import { Pipe, PipeTransform } from '@angular/core';
import { SelectedTimeframe } from '@utils/chart-interactive/selected-timeframe';

@Pipe({
  name: 'tableParameters',
  standalone: true,
})

export class TableParametersPipe implements PipeTransform {
  transform(timeframe: SelectedTimeframe): Record<string, string> {
    return { timeframe: timeframe };
  }
}
